<div class="carousel-container">
  <div class="topics-container" [ngClass]="{'is-mobile-view': isMobileView}">
    <div class="topics-list" [ngClass]="{'is-mobile-view': isMobileView}">
    @if(isLoading){
      @for(item of [1,2,3,4,5]; track $index) {
      <div class="topic-loading" [ngClass]="{'is-mobile-view': isMobileView}"></div>
      }
    }@else{
      @for (item of items; track item.id) {
      <button mat-button (click)="selectTopic(item.id)"class="topic" [class.active]="item.id === currItem.id" [ngClass]="{'is-mobile-view': isMobileView}">{{item.topic}}</button>
      }
    }
    </div>
  </div>

  <div class="questions-navs-container" [ngClass]="{'is-mobile-view': isMobileView}">
    <button mat-icon-button class="nav-btn prev" (click)="prevQuestions()" [ngClass]="{loading: isLoading}">&lt;</button>
    <div class="questions-container" [ngClass]="{'is-mobile-view': isMobileView}">
      @if(isLoading){
        @for(item of [1,2,3,4]; track $index) {
        <div class="question-card loading" [ngClass]="{'is-mobile-view': isMobileView}">
          <span class="questionText-loading"></span>
          <span class="questionText-loading"></span>
          <span class="questionText-loading"></span>
        </div>
      }
      }@else{
        @for (question of visibleQuestions; track $index) {
        <div class="question-card" (click)="selectQuestion(question)" [ngClass]="{'is-mobile-view': isMobileView}">
          <span class="questionText">{{question}}</span>
        </div>
        }
      }
    </div>
    <button mat-icon-button class="nav-btn next" (click)="nextQuestions()" [ngClass]="{loading: isLoading}">&gt;</button>
  </div>
  @if(!isLoading){
  <div class="indicators-container">
    @for (indicator of indicatorsArr ; track $index) {
      <span class="indicator" [class.active]="$index === currIndex"></span>
    }
  </div>
  }

</div>